import React from "react";
import { Button } from "primereact/button";
import { useSelector } from "react-redux";

import PermissionGate from "~/components/PermissionGate";
import AddressFileds from "../AddressFileds";
import SuccessNotification from "../SuccessNotification";
import CustomeButton from "../../../Button/index";

const TradingAddressTab = ({
  state,
  handleEditClick,
  handleTradeDiscard,
  tradeAdressOnchange,
  handleTradeSave,
  removeAddress,
  entityId,
}) => {
  const { role } = useSelector((state) => state.login);

  return (
    <>
      {state?.successMsg && (
        <SuccessNotification successMsg={state.successMsg} />
      )}
      <div className="flex justify-content-between align-items-center mb-5 mt-4">
        <h4 className="address-heading m-0">Trading Address</h4>
        <PermissionGate
          resource="entity"
          action="modify"
          resourceAttr={{ entity_id: entityId }}
        >
          <div className="flex gap-2">
            {state?.isEditingEnabled ? (
              <>
                <button className="discard-btn" onClick={handleTradeDiscard}>
                  Discard
                </button>
                <Button
                  className={`save-btn ${state?.isSaveEnabledTrade && "disable"}`}
                  loading={state?.isUpdateLoading}
                  onClick={handleTradeSave}
                  disabled={state?.isUpdateLoading || state?.isSaveEnabledTrade}
                >
                  {!state?.isUpdateLoading && "Save Changes"}
                </Button>
              </>
            ) : (
              <>
                <CustomeButton
                  label="Remove Address"
                  variant="outlined"
                  className="mr-2"
                  icon="pi pi-trash"
                  iconPos="right"
                  onClick={() =>
                    removeAddress("Trading", state?.tradingAddress?.id)
                  }
                />
                <button className="add-edit-btn" onClick={handleEditClick}>
                  Edit <span className="pi pi-pencil text-xs ml-2"></span>
                </button>
              </>
            )}
          </div>
        </PermissionGate>
      </div>
      <div className="grid w-full">
        <AddressFileds
          data={state?.tradingAddress}
          // isEdit={state?.isEditingEnabled}
          isEdit={state?.isEditingEnabled && ["GXM_ADMIN"].includes(role)}
          isLoading={state?.isLoading}
          handleOnchange={tradeAdressOnchange}
        />
      </div>
    </>
  );
};

export default TradingAddressTab;
